import * as z from 'zod';

export const CreateLabelRequest = z.object({
  label: z
    .object({
      _id: z
        .string()
        .describe('Item label ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      revision: z
        .string()
        .regex(/^-?\d+$/, 'Must be a valid Int64 string')
        .describe(
          'Revision number, which increments by 1 each time the item label is updated. To prevent conflicting changes, the current revision must be passed when updating the item label. Ignored when creating a item label.'
        )
        .optional()
        .nullable(),
      _createdDate: z
        .date()
        .describe('Date and time the item label was created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe('Date and time the item label was updated.')
        .optional()
        .nullable(),
      name: z.string().describe('Item label name.').min(1).max(50).optional(),
      icon: z.string().describe('Item label icon.').optional(),
      extendedFields: z
        .object({
          namespaces: z
            .record(z.string(), z.record(z.string(), z.any()))
            .describe(
              'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
            )
            .optional(),
        })
        .describe('Extended fields.')
        .optional(),
    })
    .describe('Item label details.'),
});
export const CreateLabelResponse = z.object({
  _id: z
    .string()
    .describe('Item label ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  revision: z
    .string()
    .regex(/^-?\d+$/, 'Must be a valid Int64 string')
    .describe(
      'Revision number, which increments by 1 each time the item label is updated. To prevent conflicting changes, the current revision must be passed when updating the item label. Ignored when creating a item label.'
    )
    .optional()
    .nullable(),
  _createdDate: z
    .date()
    .describe('Date and time the item label was created.')
    .optional()
    .nullable(),
  _updatedDate: z
    .date()
    .describe('Date and time the item label was updated.')
    .optional()
    .nullable(),
  name: z.string().describe('Item label name.').min(1).max(50).optional(),
  icon: z.string().describe('Item label icon.').optional(),
  extendedFields: z
    .object({
      namespaces: z
        .record(z.string(), z.record(z.string(), z.any()))
        .describe(
          'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
        )
        .optional(),
    })
    .describe('Extended fields.')
    .optional(),
});
export const GetLabelRequest = z.object({
  labelId: z
    .string()
    .describe('Item label ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
});
export const GetLabelResponse = z.object({
  _id: z
    .string()
    .describe('Item label ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  revision: z
    .string()
    .regex(/^-?\d+$/, 'Must be a valid Int64 string')
    .describe(
      'Revision number, which increments by 1 each time the item label is updated. To prevent conflicting changes, the current revision must be passed when updating the item label. Ignored when creating a item label.'
    )
    .optional()
    .nullable(),
  _createdDate: z
    .date()
    .describe('Date and time the item label was created.')
    .optional()
    .nullable(),
  _updatedDate: z
    .date()
    .describe('Date and time the item label was updated.')
    .optional()
    .nullable(),
  name: z.string().describe('Item label name.').min(1).max(50).optional(),
  icon: z.string().describe('Item label icon.').optional(),
  extendedFields: z
    .object({
      namespaces: z
        .record(z.string(), z.record(z.string(), z.any()))
        .describe(
          'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
        )
        .optional(),
    })
    .describe('Extended fields.')
    .optional(),
});
export const ListLabelsRequest = z.object({});
export const ListLabelsResponse = z.object({
  labels: z
    .array(
      z.object({
        _id: z
          .string()
          .describe('Item label ID.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        revision: z
          .string()
          .regex(/^-?\d+$/, 'Must be a valid Int64 string')
          .describe(
            'Revision number, which increments by 1 each time the item label is updated. To prevent conflicting changes, the current revision must be passed when updating the item label. Ignored when creating a item label.'
          )
          .optional()
          .nullable(),
        _createdDate: z
          .date()
          .describe('Date and time the item label was created.')
          .optional()
          .nullable(),
        _updatedDate: z
          .date()
          .describe('Date and time the item label was updated.')
          .optional()
          .nullable(),
        name: z.string().describe('Item label name.').min(1).max(50).optional(),
        icon: z.string().describe('Item label icon.').optional(),
        extendedFields: z
          .object({
            namespaces: z
              .record(z.string(), z.record(z.string(), z.any()))
              .describe(
                'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
              )
              .optional(),
          })
          .describe('Extended fields.')
          .optional(),
      })
    )
    .optional(),
});
export const QueryLabelsRequest = z.object({
  query: z
    .object({
      filter: z
        .object({
          _id: z
            .object({
              $eq: z.string(),
              $in: z.array(z.string()),
              $ne: z.string(),
              $nin: z.array(z.string()),
            })
            .partial()
            .strict()
            .optional(),
          icon: z
            .object({ $exists: z.boolean() })
            .partial()
            .strict()
            .optional(),
          name: z
            .object({
              $eq: z.string(),
              $in: z.array(z.string()),
              $ne: z.string(),
              $nin: z.array(z.string()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          _createdDate: z
            .object({
              $eq: z.string(),
              $gt: z.string(),
              $gte: z.string(),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          _updatedDate: z
            .object({
              $eq: z.string(),
              $gt: z.string(),
              $gte: z.string(),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          $and: z.array(z.any()).optional(),
          $or: z.array(z.any()).optional(),
          $not: z.any().optional(),
        })
        .strict()
        .optional(),
      sort: z.array(z.object({})).optional(),
    })
    .catchall(z.any())
    .describe('Query options.'),
});
export const QueryLabelsResponse = z.object({
  labels: z
    .array(
      z.object({
        _id: z
          .string()
          .describe('Item label ID.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        revision: z
          .string()
          .regex(/^-?\d+$/, 'Must be a valid Int64 string')
          .describe(
            'Revision number, which increments by 1 each time the item label is updated. To prevent conflicting changes, the current revision must be passed when updating the item label. Ignored when creating a item label.'
          )
          .optional()
          .nullable(),
        _createdDate: z
          .date()
          .describe('Date and time the item label was created.')
          .optional()
          .nullable(),
        _updatedDate: z
          .date()
          .describe('Date and time the item label was updated.')
          .optional()
          .nullable(),
        name: z.string().describe('Item label name.').min(1).max(50).optional(),
        icon: z.string().describe('Item label icon.').optional(),
        extendedFields: z
          .object({
            namespaces: z
              .record(z.string(), z.record(z.string(), z.any()))
              .describe(
                'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
              )
              .optional(),
          })
          .describe('Extended fields.')
          .optional(),
      })
    )
    .optional(),
  pagingMetadata: z
    .object({
      count: z
        .number()
        .int()
        .describe('Number of items returned in the response.')
        .optional()
        .nullable(),
      cursors: z
        .object({
          next: z
            .string()
            .describe('Cursor pointing to next page in the list of results.')
            .optional()
            .nullable(),
          prev: z
            .string()
            .describe(
              'Cursor pointing to previous page in the list of results.'
            )
            .optional()
            .nullable(),
        })
        .describe('Offset that was requested.')
        .optional(),
      hasNext: z
        .boolean()
        .describe(
          'Indicates if there are more results after the current page.\nIf `true`, another page of results can be retrieved.\nIf `false`, this is the last page.'
        )
        .optional()
        .nullable(),
    })
    .describe('The metadata of the paginated results.')
    .optional(),
});
export const CountLabelsRequest = z.object({
  options: z
    .object({
      filter: z
        .record(z.string(), z.any())
        .describe('Filter for counting labels.')
        .optional()
        .nullable(),
    })
    .optional(),
});
export const CountLabelsResponse = z.object({
  count: z.number().int().describe('Counted labels.').optional(),
});
export const UpdateLabelRequest = z.object({
  _id: z
    .string()
    .describe('Item label ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  label: z
    .object({
      _id: z
        .string()
        .describe('Item label ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      revision: z
        .string()
        .regex(/^-?\d+$/, 'Must be a valid Int64 string')
        .describe(
          'Revision number, which increments by 1 each time the item label is updated. To prevent conflicting changes, the current revision must be passed when updating the item label. Ignored when creating a item label.'
        ),
      _createdDate: z
        .date()
        .describe('Date and time the item label was created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe('Date and time the item label was updated.')
        .optional()
        .nullable(),
      name: z.string().describe('Item label name.').min(1).max(50).optional(),
      icon: z.string().describe('Item label icon.').optional(),
      extendedFields: z
        .object({
          namespaces: z
            .record(z.string(), z.record(z.string(), z.any()))
            .describe(
              'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
            )
            .optional(),
        })
        .describe('Extended fields.')
        .optional(),
    })
    .describe('Item label to update.'),
});
export const UpdateLabelResponse = z.object({
  _id: z
    .string()
    .describe('Item label ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  revision: z
    .string()
    .regex(/^-?\d+$/, 'Must be a valid Int64 string')
    .describe(
      'Revision number, which increments by 1 each time the item label is updated. To prevent conflicting changes, the current revision must be passed when updating the item label. Ignored when creating a item label.'
    )
    .optional()
    .nullable(),
  _createdDate: z
    .date()
    .describe('Date and time the item label was created.')
    .optional()
    .nullable(),
  _updatedDate: z
    .date()
    .describe('Date and time the item label was updated.')
    .optional()
    .nullable(),
  name: z.string().describe('Item label name.').min(1).max(50).optional(),
  icon: z.string().describe('Item label icon.').optional(),
  extendedFields: z
    .object({
      namespaces: z
        .record(z.string(), z.record(z.string(), z.any()))
        .describe(
          'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
        )
        .optional(),
    })
    .describe('Extended fields.')
    .optional(),
});
export const DeleteLabelRequest = z.object({
  labelId: z
    .string()
    .describe('ID of the item label.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
});
export const DeleteLabelResponse = z.object({});
export const BulkDeleteLabelsRequest = z.object({
  ids: z.array(z.string()).max(200),
});
export const BulkDeleteLabelsResponse = z.object({
  results: z
    .array(
      z.object({
        itemMetadata: z
          .object({
            _id: z
              .string()
              .describe(
                "Item ID. Should always be available, unless it's impossible (for example, when failing to create an item)."
              )
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional()
              .nullable(),
            originalIndex: z
              .number()
              .int()
              .describe(
                'Index of the item within the request array. Allows for correlation between request and response items.'
              )
              .optional(),
            success: z
              .boolean()
              .describe(
                'Whether the requested action was successful for this item. When `false`, the `error` field is populated.'
              )
              .optional(),
            error: z
              .object({
                code: z.string().describe('Error code.').optional(),
                description: z
                  .string()
                  .describe('Description of the error.')
                  .optional(),
                data: z
                  .record(z.string(), z.any())
                  .describe('Data related to the error.')
                  .optional()
                  .nullable(),
              })
              .describe('Details about the error in case of failure.')
              .optional(),
          })
          .describe('Metadata for labels deletion.')
          .optional(),
      })
    )
    .optional(),
  bulkActionMetadata: z
    .object({
      totalSuccesses: z
        .number()
        .int()
        .describe('Number of items that were successfully processed.')
        .optional(),
      totalFailures: z
        .number()
        .int()
        .describe("Number of items that couldn't be processed.")
        .optional(),
      undetailedFailures: z
        .number()
        .int()
        .describe(
          'Number of failures without details because detailed failure threshold was exceeded.'
        )
        .optional(),
    })
    .describe('Metadata for the API call.')
    .optional(),
});
